import { render } from "./HomeQrTypes.vue?vue&type=template&id=2bd3f5c4&scoped=true&ts=true&lang=pug"
import script from "./HomeQrTypes.vue?vue&type=script&lang=ts&setup=true"
export * from "./HomeQrTypes.vue?vue&type=script&lang=ts&setup=true"

import "./HomeQrTypes.vue?vue&type=style&index=0&id=2bd3f5c4&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bd3f5c4"]])

export default __exports__